export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пропозиції"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мої угоди"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мої оголошення"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Угоди"])}
}